import IconBulb from '@/assets/bulb.svg?react';
import IconInfo from '@/assets/info-shape.svg?react';
import cn from '@/utils/cn';

interface Props {
  children: React.ReactNode;
  className?: string;
  color?: 'blue' | 'yellow' | 'red';
  border?: boolean;
  variant?: 'default' | 'primary';
  icon?: 'bulb' | 'info';
}
const Hint = ({
  children,
  color = 'yellow',
  border = true,
  className,
  variant = 'default',
  icon = 'info',
}: Props) => {
  return (
    <div
      aria-label="hint-message"
      className={cn(
        'caption flex w-full items-center rounded-md px-2.5 py-2 text-dark-gray-500',
        color === 'yellow' && 'bg-yellow-50 outline-yellow-500',
        color === 'blue' && 'bg-gray-200 outline-dark-gray-200',
        color === 'red' && 'bg-red-50 text-red-500 outline-red-400',
        border &&
          `outline outline-1 ${color === 'yellow' && variant === 'primary' && 'outline-2'}`,
        variant === 'primary' && 'flex-col items-start gap-1 p-3',
        className
      )}
    >
      {variant === 'primary' ? (
        children
      ) : (
        <>
          {icon === 'info' && (
            <IconInfo
              width="18"
              className={cn(
                'mr-1.5 shrink-0 text-primary',
                color === 'yellow' && 'text-yellow-500',
                color === 'red' && 'text-red-400'
              )}
            />
          )}
          {icon === 'bulb' && (
            <IconBulb
              width="18"
              className={cn(
                'mr-1.5 shrink-0',
                color === 'yellow' ? 'text-yellow-500' : 'text-primary'
              )}
            />
          )}
          {children}
        </>
      )}
    </div>
  );
};

const Title = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div className={cn('flex items-center gap-1.5', className)}>
      <IconInfo width="20" className="shrink-0 text-yellow-500" />
      <p className="caption-large-semi text-oxford-blue-500">{children}</p>
    </div>
  );
};

const Description = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        'caption-large flex flex-col gap-1 text-dark-gray-500',
        className
      )}
    >
      {children}
    </div>
  );
};

Hint.Title = Title;
Hint.Description = Description;

export { Hint };
